import { type JSX } from 'react';
import BaseNavbar, { type NavItemProps } from '@/shared/components/BaseNavbar';
import ThreeDotsMenu, { standardItems } from '@/shared/components/flip-ui-kit/ThreeDotsMenu';
import { ConnectButton } from '@/shared/components/RainbowKit';
import DropletIcon from '@/shared/icons/flip-ui-kit/large/Droplet';
import GlobeIcon from '@/shared/icons/flip-ui-kit/large/Globe';

const navItems: NavItemProps[] = [
  {
    type: 'link',
    href: process.env.NEXT_PUBLIC_LP_URL as string,
    Icon: DropletIcon,
    children: 'Provide Liquidity',
  },
  {
    type: 'link',
    href: process.env.NEXT_PUBLIC_EXPLORER_URL as string,
    Icon: GlobeIcon,
    children: 'Explorer',
  },
];

export const Navbar = (): JSX.Element => (
  <BaseNavbar
    logoHref="/"
    navItems={navItems}
    actions={
      <>
        <ConnectButton />
        <ThreeDotsMenu items={standardItems} />
      </>
    }
    hamburgerReplacement={
      <div className="flex items-center gap-2">
        <ConnectButton />
        <ThreeDotsMenu items={standardItems} />
      </div>
    }
  />
);
